/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_Point_1Inputs */

const en_services_svc_money_point_1 = /** @type {(inputs: Services_Svc_Money_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead finding, research and scoring against your criteria`)
};

const lv_services_svc_money_point_1 = /** @type {(inputs: Services_Svc_Money_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potenciālo klientu meklēšana, izpēte un novērtēšana pēc Jūsu kritērijiem`)
};

/**
* | output |
* | --- |
* | "Lead finding, research and scoring against your criteria" |
*
* @param {Services_Svc_Money_Point_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_point_1 = /** @type {((inputs?: Services_Svc_Money_Point_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_Point_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_point_1(inputs)
	return en_services_svc_money_point_1(inputs)
});